<template>
    <div>
        <material></material>
    </div>
</template>

<script>
  import material from "../components/material"

  export default {
    name: "",
    components:{
      material
    }
  }
</script>

<style scoped>

</style>
